import { type UserSummary } from '@/lib/types';
import googleAccessTokenStore from '../../utils/google/googleAccessTokenStore';

const GOOGLE_USER_INFO_URL = 'https://openidconnect.googleapis.com/v1/userinfo';

type GoogleUserInfoResponse = {
  email: string;
  name: string;
  picture: string;
};

const getGoogleAccountInfo = async (): Promise<UserSummary | null> => {
  try {
    const accessToken = googleAccessTokenStore.getAccessToken();

    if (accessToken === null || accessToken.isExpired()) {
      return null;
    }

    const userInfoResponse = await fetch(GOOGLE_USER_INFO_URL, {
      headers: {
        Authorization: `Bearer ${accessToken.getValue()}`,
      },
    });
    const userInfo: GoogleUserInfoResponse = await userInfoResponse.json();

    return {
      name: userInfo.name,
      email: userInfo.email,
      picture: userInfo.picture,
    };
  } catch {
    // no-op: assume errors mean no (valid) account is connected
    return null;
  }
};

export default getGoogleAccountInfo;
